export enum FeatureFlagKeys {
    AbsenteeBidsDefectionService = 'ff_use_absentee_bids_defection_service',
    NewAddCreditCardFlow = 'ff_new_add_credit_card_flow',
    NewAuthPagerModal = 'ff_new_auth_pager_modal',
    NewMobileCheckout = 'ff_new_mobile_checkout',
    PriceArchive = 'ff_price_archive',
    VipBenefits = 'ff_vip_benefits',
}
// TODO: Add feature flags here
// NewItemPageLayout = 'ff_laac-5678_new-item-page-layout',

export type FeatureFlags = Partial<Record<FeatureFlagKeys, boolean>>;
